<template lang="pug">
  b-row
    .col-xl-12
      panel(:title='$t("title.bet_limit_settings")' :bodyClass="'childBody'")
        b-row
          .col-sm-12.col-md-12.col-lg-12.col-xl-12
            #tblModal.table-sm.table-responsive.betLimit
              table.table.table-bordered
                thead
                  tr
                    th &nbsp;
                    th.text-center(style="width:20%;") {{ $t("ui.min_bet") }}
                    th.text-center(style="width:20%;") {{ $t("ui.max_bet") }}
                    th.text-center(style="width:20%;") {{ $t("ui.max_per_match") }}
                tbody
                  tr
                    th {{ $t("ui.soccer") }}
                    td.text-center {{ soccer_min_bet }}
                    td.text-center {{ soccer_max_bet }}
                    td.text-center {{ soccer_max_per_match }}
                  tr
                    th {{ $t("ui.basketball") }}
                    td.text-center {{ basketball_min_bet }}
                    td.text-center {{ basketball_max_bet }}
                    td.text-center {{ basketball_max_per_match }}
                  tr
                    th {{ $t("ui.tennis") }}
                    td.text-center {{ tennis_min_bet }}
                    td.text-center {{ tennis_max_bet }}
                    td.text-center {{ tennis_max_per_match }}
                  tr
                    th {{ $t("ui.baseball") }}
                    td.text-center {{ baseball_min_bet }}
                    td.text-center {{ baseball_max_bet }}
                    td.text-center {{ baseball_max_per_match }}
                  tr
                    th {{ $t("ui.parlay") }}
                    td.text-center {{ parlay_min_bet }}
                    td.text-center {{ parlay_max_bet }}
                    td.text-center {{ parlay_max_per_match }}
                  tr
                    th {{ $t("ui.esports") }}
                    td.text-center {{ esports_min_bet }}
                    td.text-center {{ esports_max_bet }}
                    td.text-center {{ esports_max_per_match }}
                  tr
                    th {{ $t("ui.others_sports") }}
                    td.text-center {{ others_min_bet }}
                    td.text-center {{ others_max_bet }}
                    td.text-center {{ others_max_per_match }}
                  tr
                    th {{ $t("ui.correct_score_bl") }}
                    td.text-center {{ cs_min_bet }}
                    td.text-center {{ cs_max_bet }}
                    td.text-center {{ cs_max_per_match }}
                  tr(v-show="isPlatformShow('LC')")
                    th {{ $t("ui.live_casino") }}
                    td#betLimit(colspan=3)
                      template(v-if="isSearch")
                        b-form-checkbox-group(
                          ref="livecasino_bet_limit_packages"
                          v-model.trim.lazy="livecasino_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          stacked
                          disabled
                        )
                      template(v-else)
                        b-form-select(
                          ref="livecasino_bet_limit_packages"
                          v-model.trim.lazy="livecasino_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          size="sm"
                          disabled
                        )
                  tr(v-show="isPlatformShow('LO')")
                    th {{ $t("ui.lotto") }}
                    td(colspan=3)
                      template(v-if="isSearch")
                        b-form-checkbox-group(
                          ref="lotto_bet_limit_packages"
                          v-model.trim.lazy="lotto_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          stacked
                          disabled
                        )
                      template(v-else)
                        b-form-select(
                          ref="lotto_bet_limit_packages"
                          v-model.trim.lazy="lotto_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          size="sm"
                          disabled
                        )
                  tr.d-none(v-show="isPlatformShow('KN')")
                    th {{ $t("ui.keno") }}
                    td(colspan=3)
                      template(v-if="isSearch")
                        b-form-checkbox-group(
                          ref="keno_bet_limit_packages"
                          v-model.trim.lazy="keno_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          stacked
                          disabled
                        )
                      template(v-else)
                        b-form-select(
                          ref="keno_bet_limit_packages"
                          v-model.trim.lazy="keno_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          size="sm"
                          disabled
                        )
                  tr.d-none(v-show="isPlatformShow('CF')")
                    th {{ $t("ui.esports2") }}
                    td(colspan=3)
                      template(v-if="isSearch")
                        b-form-checkbox-group(
                          ref="cockfight_bet_limit_packages"
                          v-model.trim.lazy="cockfight_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          stacked
                          disabled
                        )
                      template(v-else)
                        b-form-select(
                          ref="cockfight_bet_limit_packages"
                          v-model.trim.lazy="cockfight_bet_limit_packages"
                          :options="bet_limit_packages_options"
                          size="sm"
                          disabled
                        )
                  tr(v-show="isPlatformShow('LT')")
                    th {{ $t("ui.lottery") }}
                    td(colspan=3)
                      template(v-if="isSearch")
                        b-form-checkbox-group(
                          ref="lottery_bet_limit_packages"
                          v-model.trim.lazy="lottery_bet_limit_packages"
                          :options="bet_limit_lottery_packages_options"
                          stacked
                          disabled
                        )
                      template(v-else)
                        b-form-select(
                          ref="lottery_bet_limit_packages"
                          v-model.trim.lazy="lottery_bet_limit_packages"
                          :options="bet_limit_lottery_packages_options"
                          size="sm"
                          disabled
                        )
</template>

<script>
export default {
  props: {
    accountID: "",
    platformList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      soccer_min_bet: "0",
      soccer_max_bet: "0",
      soccer_max_per_match: "0",
      basketball_min_bet: "0",
      basketball_max_bet: "0",
      basketball_max_per_match: "0",
      tennis_min_bet: "0",
      tennis_max_bet: "0",
      tennis_max_per_match: "0",
      baseball_min_bet: "0",
      baseball_max_bet: "0",
      baseball_max_per_match: "0",
      parlay_min_bet: "0",
      parlay_max_bet: "0",
      parlay_max_per_match: "0",
      esports_min_bet: "0",
      esports_max_bet: "0",
      esports_max_per_match: "0",
      others_min_bet: "0",
      others_max_bet: "0",
      others_max_per_match: "0",
      cs_min_bet: "0",
      cs_max_bet: "0",
      cs_max_per_match: "0",
      livecasino_bet_limit_packages:['A'],
      lotto_bet_limit_packages: ['A'],
      keno_bet_limit_packages: ['A'],
      cockfight_bet_limit_packages: ['A'],
      lottery_bet_limit_packages: ['A']
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    currencyCode: function() {
      return this.$store.getters.getAccountCurrency
    },
    bet_limit_packages_options: function() {
      let packages = ['A','B','C','D','E','F','G']
      let result = []
      if(packages) {
        packages.sort().forEach((value, index) => {
          result.push({ value:value, text:this.$t("ui.combine.bet_limit_" + this.currencyCode + value)})
        })
      }
      return result
    },
    bet_limit_lottery_packages_options: function() {
      let packages = ['A']
      let result = []
      if(packages) {
        packages.sort().forEach((value, index) => {
          result.push({ value:value, text:this.$t("ui.combine.bet_limit_lottery_" + this.currencyCode + value)})
        })
      }
      return result
    }
  },
  methods: {
    isPlatformShow: function(mode) {
      switch(mode){
        case "LC":
          return this.platformList.includes("LIVECASINO")
        case "SL":
          return this.platformList.includes("SLOTS")
        case "LO":
          return this.platformList.includes("LOTTO")
        case "KN":
          return this.platformList.includes("KENO")
        case "CF":
          return this.platformList.includes("COCKFIGHT")
        case "LT":
          return this.platformList.includes("LOTTERY")
      }
    }
  }
}
</script>
